import React from 'react';

import Companies from './Companies';
import Testimonial from './Testimonial';

const CompaniesAndLeaders = () => {
  return (
    <aside className="my-80 border border-x-0 border-y border-solid border-grayscale-gray py-80 sm:mt-112 md:py-112">
      <h3 className="m-0 text-center font-suisse-intl-mono text-caption-lg font-normal text-grayscale-charcoal">
        Companies and Leaders Rely on our Journalism
      </h3>
      <Companies />
      <div className="mx-auto mt-80 flex max-w-[513px] flex-col items-start gap-32 md:mt-48 md:max-w-full md:flex-row md:justify-between lg:gap-24">
        <Testimonial
          quote="<span>I read it every day</span> and really appreciate what you all do for the industry."
          author="Mark Zuckerberg"
          title="CEO & Founder, Meta"
        />
        <Testimonial
          quote="The Information is one of the few <span>trusted sources of tech news</span> that I reference on a daily basis."
          author="Vinod Khosla"
          title="Founder, Khosla Ventures"
        />
        <Testimonial
          quote="I subscribe to The Information because it is the <span>highest quality</span> news in tech today."
          author="Julia Hartz"
          title="CEO, Eventbrite"
        />
      </div>
    </aside>
  );
};

export default CompaniesAndLeaders;
